import { Injectable, EventEmitter } from "@angular/core";
import { KreFormFieldConfig } from "@kre-form/core";

@Injectable()
export class KreFormAntService {
  btnEvent = new EventEmitter();
  fieldEvent = new EventEmitter();

  workList = [];

  constructor() {}

  fieldOperational(sign: string, field: KreFormFieldConfig) {
    this.fieldEvent.emit({
      sign: sign,
      field: field
    });
  }

  groupOperational(type: string, field: KreFormFieldConfig) {
    this.btnEvent.emit({
      type: type,
      field: field
    });
  }
}
